import { Component, OnInit } from '@angular/core';
import { TabService } from 'src/app/panel/services/tab.service';

import { ReportService } from '../../services/report.service';
import { EvaluationCriteriaService } from 'src/app/events/services/evaluation-criteria.service';

@Component({
  selector: 'app-new-report',
  templateUrl: './new-report.component.html',
  styleUrls: ['./new-report.component.scss']
})
export class NewReportComponent implements OnInit {
  
  constructor(
    public reportService: ReportService,
    public tabService: TabService,
    private evaluationCriteriaService : EvaluationCriteriaService
  ) {
    this.tabService.setCurrentTab('reports-tab');
  }

  ngOnInit(): void {
    this.evaluationCriteriaService.initEvaluationCriteria().subscribe()
    document.querySelector('body')!.style.backgroundColor = 'rgb(237,232,232)';
  }

}
